import { Flex, Skeleton } from 'antd'
import React from 'react'
import classnames from 'classnames'

type Props = {
  height: string;
  width: string;
  amount?: number;
  centered?: boolean;
  withPadding?: boolean;
  withTitle?: boolean;
  direction?: 'row' | 'column'
}

export function MobileSkeletonLoader({ width, height = '80px', withPadding, amount = 1, withTitle, direction = 'column', centered = false }: Props) {
  return (
    <div className={classnames('skeletonLoader', withPadding && 'skeletonWithPadding', withTitle && 'skeletonWithTitle', centered && 'centered')}>
      <Flex gap={12} vertical={direction === 'column'}>
        {withTitle && (
          <Flex align="center" justify="space-between">
            <Skeleton style={{ width: '25%' }} paragraph={{ rows: 0 }} active title={{ width: '100%' }} />
            <Skeleton style={{ width: '25%' }} paragraph={{ rows: 0 }} active title={{ width: '100%' }} />
          </Flex>
        )}
        {Array.from({ length: amount }).map((_, index) => (
          <Skeleton.Node key={index} active fullSize style={{ width, height, borderRadius: '16px' }} />
        ))}
      </Flex>
    </div>
  )
}
